 const frequencyModel = [
  {
    name: 'Daily',
    path: 'daily'
  },
  {
    name: 'Weekly',
    path: 'weekly'
  },
  {
    name: 'Monthly',
    path: 'monthly'
  },
  {
    name: 'Twice a month',
    path: 'twice-a-month'
  },
  {
    name: 'Bimonthly',
    path: 'bimonthly'
  },
  {
    name: 'Whenever',
    path: 'whenever'
  },
  {
    name: 'Monday to Friday',
    path: 'monday-to-friday'
  }
];
export default frequencyModel;